import {
  AddExpenseVatResponse,
  DeletedExpenseVat,
  ExpenseVatCommonResponse,
  ExpenseVatError,
  ExpenseVatItem,
  ExpenseVatResponse,
} from '@core/interface/expense-vat';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ExpenseVatActions = createActionGroup({
  source: 'ExpenseVat',
  events: {
    'Load Expense Vats': props<PagePayload>(),
    'Load Expense Vats Success': props<ExpenseVatResponse>(),
    'Load Expense Vats Failure': props<ExpenseVatError>(),
    'Add Edit Expense Vat': props<ExpenseVatItem>(),
    'Add Expense Vat Success': props<AddExpenseVatResponse>(),
    'Update Expense Vat Success': props<AddExpenseVatResponse>(),
    'Add Expense Vat Failure': props<ExpenseVatError>(),
    'Update Expense Vat Failure': props<ExpenseVatError>(),
    'Delete Expense Vat': props<{ id: number }>(),
    'Delete Expense Vat Success': props<DeletedExpenseVat>(),
    'Delete Expense Vat Failure': props<ExpenseVatError>(),
    'Reset Delete Status': emptyProps(),
    'Reset Expense Vats': emptyProps(),
  },
});
